<template>
	<MStateBox :loading="announcement.loading" :empty="isEmpty" class="ir-module-block">
		<CCardNoticePanel v-for="(item, index) in pageData" :key="index" :item="item"></CCardNoticePanel>
		<slot name="footer"></slot>
	</MStateBox>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import CCardNoticePanel from '@rebuild/components/CCardNoticePanel.vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import MStateBox from '@/view/enterprise_rebuild/components/MStateBox.vue';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';

// 数据层
const { announcement } = useModuleData(); // 变量名与 loaderFactories key 一致
const { config, loadModuleConfig } = useModuleConfig();

// 保持与历史组件相同的数据访问路径：res?.data || []
const pageData = computed(() => {
	return (announcement.data?.data || []).slice(0, 3);
});

// 空状态判断
const isEmpty = computed(() => {
	return announcement.empty || !announcement.data?.data?.length;
});

const tabOption = computed(() => {
	return (config.value?.tab || []).sort((a, b) => a.sort - b.sort).filter(v => v.isPublish);
});

async function refresh(done) {
	await loadModuleConfig('announcement');
	if (tabOption.value.length) {
		let allTab = tabOption.value.find(v => v.id === 'announcement_all' && v.isPublish);
		let classificationIds;
		if (allTab) {
			classificationIds = '';
		} else {
			// 拍平主tab和subTabList，形成新数组
			const allTabs = tabOption.value.flatMap(tab => [tab, ...(tab.subTabList || [])]);
			classificationIds = allTabs.map(v => v.id.slice(11).replace(/,/g, '#')).join(',');
		}
		await announcement.refresh({
			pageStart: 0,
			pageNum: 20,
			classificationIds
		});
	} else {
		announcement.loading = false;
	}

	done && done();
}

onMounted(() => {
	refresh();
});
</script>

<style lang="less" scoped></style>
